module.exports = __webpack_public_path__ + "img/item1.682ec3cb.jpg";